import React from "react";
// import { useParams } from "react-router-dom";
// import projectList from "../project/projectList";
import ProjectDetailsLeft from "../../components/ProjectDetails/ProjectDetailsLeft";
import ProjectDetailsRight from "../../components/ProjectDetails/ProjectDetailsRight";

const ProjectDetailsMain = ({ project }) => {
  // const projectData = {
  //   category: "Circular Elevators",
  //   customer: "360° PANORAMIC VIEWS",
  //   startDate: "2 TO 6 PASSENGER",
  //   endDate: "SPEED 0.25 TO 1 MPS",
  //   rating: 5,
  //   address: "Dhaka 102, 8000 Sent Behaibior, Road 45, House of Street",
  //   phone: "+32566 - 800 - 890",
  //   fax: "1234 - 58963 - 007",
  //   email: "nafiz1223@gmail.com",
  //   socialLinks: [
  //     { url: "/blog-details", label: "Instagram", iconClass: "icon-instagram" },
  //     { url: "/blog-details", label: "Facebook", iconClass: "icon-facebook-f" },
  //     { url: "/blog-details", label: "Twitter", iconClass: "icon-Vector" },
  //     {
  //       url: "/blog-details",
  //       label: "LinkedIn",
  //       iconClass: "icon-linkedin-in",
  //     },
  //   ],
  //   contactImage: ProjectCircularBoxLeft,
  // };

  // const projectDataTwo = {
  //   mainImage: ProjectDetailsImg1,
  //   title: "360° PANORAMIC VIEWS",
  //   text1:
  //     "A circular elevator transude a sophisticated and high- class aesthetic with its unique design and panoramic views. The elevator car is often cylindrical or tube- shaped with transparent walls, offering passengers an unparalleled view during their ascent or decent. The advanced engineering of these lifts ensures smooth operation, enhancing the architectural appeal of any building. Ideal for high-end settings such as 5 and 7 star hotels, corporate headquarters, or luxurious bungalows, circular lifts combine elegance with a benchmark for chic vertical transport solutions.",
  //   // text2: "Dimension of Cicular Lift",
  //   points: [
  //     "Elegant Interior Lighting and Bespoke Design — crafted to complement the luxury of every space.",
  //     "Energy-Efficient Engineering — ensuring sustainable and responsible vertical transportation.",
  //     "Interactive Touchscreen Panels — offering intuitive and personalized user experiences.",
  //     "Immersive Acoustic Soundscapes — delivering a serene and sophisticated ride environment.",
  //     // "Optimize your logistics with our expertise.",
  //   ],
  //   additionalImages: [ProjectDetailsBoxImg1, ProjectDetailsBoxImg2],
  //   text3:
  //     "Experience seamless sophistication with every ascent — where innovation, luxury, and panoramic beauty unite.",
  //   tableData: [
  //     { passenger: "4", area: "0.77", liftWellSize: "1750", entrance: "700" },
  //     { passenger: "6", area: "1.10", liftWellSize: "1800", entrance: "800" },
  //     { passenger: "8", area: "1.43", liftWellSize: "1900", entrance: "800" },
  //     { passenger: "10", area: "1.75", liftWellSize: "2000", entrance: "800" },
  //   ],
  // };

  // const { projectId } = useParams();
  // const project = projectList.find((p) => p.id === projectId);

  if (!project) return <div>Project not found.</div>;


  return (
    <React.Fragment>
      {/*Project Details Start*/}
      <section className="project-details">
        {/* <h1 className="project-details__main-title">{projectData.category}</h1> */}
        <div className="container">
          <div className="row">
            <div className="col-xl-4">
            <ProjectDetailsLeft projectInfo={project.basicInfo} />
            </div>
            <div className="col-xl-8">
            <ProjectDetailsRight projectData={project.details} />
            </div>
          </div>
        </div>
      </section>
      {/*Project Details End*/}
    </React.Fragment>
  );
};

export default ProjectDetailsMain;
